import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["altText"];
import React from 'react';
import { IconCross } from "../icons";
import InputActionButton from "./InputActionButton";
import { jsx as ___EmotionJSX } from "@emotion/core";

var InputClearButton = function InputClearButton(_ref) {
  var _ref$altText = _ref.altText,
      altText = _ref$altText === void 0 ? 'Clear input' : _ref$altText,
      rest = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(InputActionButton, _extends({
    icon: IconCross,
    altText: altText
  }, rest));
};

InputClearButton.displayName = 'InputClearButton';
export default InputClearButton;